import AddInvestorForm from './AddInvestorForm';

export default AddInvestorForm;
